import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box'

const Accordion = withStyles({
  root: {
    fontFamily: 'Montserrat',
    marginBottom: '30px',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
  
    marginBottom: -1,

  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
 
  },
}))(MuiAccordionDetails);

export default function CustomizedAccordions(props) {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div style={{marginTop: '-10px', width: '100%'}}>
      <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary style={{backgroundColor: '#F2F2F2'}} aria-controls="panel1d-content" id="panel1d-header"  expandIcon={<ExpandMoreIcon style={{color: '#DC251A'}} />} >
          <Typography style={{fontFamily: 'Montserrat', fontWeight: '700', fontSize: '18px'}}>EVENT INFORMATION</Typography>
        </AccordionSummary>
        <AccordionDetails style={{backgroundColor: '#F2F2F2', width: '100%', marginBottom: '15px'}}>
   
            <Grid container style={{marginTop: '-26px'}}>
          
            <Grid item lg={2} md={12} sm={12} xs={12} >
             <p style={{fontFamily: 'Montserrat', fontWeight: 600, color: '#DC251A', fontSize: '14px'}}>EVENT TYPE</p>
             <p style={{fontFamily: 'Montserrat',fontWeight: 500,  fontSize: '14px', marginTop: '-15px'}}>{props.eventType}</p>
            
            </Grid>
           
            <Grid item lg={2} md={12} sm={12} xs={12} >
             <p style={{fontFamily: 'Montserrat', fontWeight: 600, color: '#DC251A', fontSize: '14px'}}>PLACE</p>
             <p style={{fontFamily: 'Montserrat', fontWeight: 500,fontSize: '15px', marginTop: '-15px', fontSize: '14px'}}>{props.place}</p>
            </Grid>
           
            <Grid item lg={2} md={12} sm={12} xs={12} >
             <p style={{fontFamily: 'Montserrat', fontWeight: 600, color: '#DC251A', fontSize: '14px'}}>DATE</p>
             <p style={{fontFamily: 'Montserrat', fontWeight: 500, fontSize: '15px', marginTop: '-15px', fontSize: '14px'}}>{props.eventDate}</p>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}  >
            <p style={{fontFamily: 'Montserrat', fontWeight: 600, color: '#DC251A', marginTop: '5px', fontSize: '14px'}}>EVENT DESCRIPTION</p>
            <Box  bgcolor="white" style={{minHeight: "60px"}} >
           <p style={{fontFamily: 'Montserrat', fontWeight: 500, fontSize: '14px', padding: '8px', fontSize: '14px', marginTop: '-8px'}}>
               {props.eventDescription}
           
           </p>
            </Box>
            </Grid>
         </Grid>
   
         
             
        </AccordionDetails>
      </Accordion>
    </div>
  );
}